/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useLocation, useNavigate } from 'react-router-dom';

// Misc imports
import { TEST_SETS_SEARCH_PARAMS, TEST_SET_TABS } from '../../../constants/testSets';

export const useTestSetNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const navigateToCreateTestSet = () => {
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST);
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TAB);
    searchParams.set(TEST_SETS_SEARCH_PARAMS.CREATE_TEST, true);
    searchParams.set(TEST_SETS_SEARCH_PARAMS.ACTIVE_TAB, TEST_SET_TABS.TEST_SET.key);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };

  const navigateToTestSetsList = () => {
    // Clear all possible search params for "nested" views
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST);
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.CREATE_TEST);
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TAB);
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST_NAME);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString()
    }, { replace: true });
  };

  const navigateToTestSet = (id, tab, name = '', replaceName = true) => {
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST);
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.CREATE_TEST);
    searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TAB);
    if(replaceName) {
      searchParams.delete(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST_NAME);
    }

    searchParams.set(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST, id);
    searchParams.set(TEST_SETS_SEARCH_PARAMS.ACTIVE_TAB, tab);

    if(name) {
      searchParams.set(TEST_SETS_SEARCH_PARAMS.ACTIVE_TEST_NAME, name);
    }

    navigate({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };

  return {
    navigateToTestSetsList,
    navigateToTestSet,
    navigateToCreateTestSet
  };
};
